"use client";
import { useGlobalModalContext } from "@components/GlobalModalProvider/GlobalModalProvider";
import { CommonCMS } from "@lib/constants/contentful";
import { useMicrocopy } from "@lib/contentful/microcopy/MicrocopyContext";
import { ModalTypes } from "@lib/enums/ModalTypes";
import { Text } from "@ui/components/content/text/Text";
import { SelectDropdownItem } from "@ui/components/overlay/select-dropdown/SelectDropdown";
import { defaultUnderlineStyle } from "@ui/css/common";

interface SizeGuideProps {
    gender: string;
    targetGroup?: string;
    materialGroup?: string;
    isToolbar?: boolean;
    isFootwear?: boolean;
    type?: string;
}

export const SizeGuide = ({
    gender,
    isToolbar = false,
    targetGroup,
    materialGroup,
    isFootwear,
    type,
}: SizeGuideProps) => {
    const { getMultiple } = useMicrocopy();
    const microcopies = (() => {
        return getMultiple(CommonCMS.shared, [
            CommonCMS.guide.socks,
            CommonCMS.guide.belts,
            CommonCMS.guide.laces,
            CommonCMS.guide.kids,
            CommonCMS.size.guideModalTitle,
        ]);
    })();
    const isSocks = materialGroup === microcopies[CommonCMS.guide.socks];
    const isBelts = materialGroup === microcopies[CommonCMS.guide.belts];
    const isLaces = materialGroup === microcopies[CommonCMS.guide.laces];
    const forKids = targetGroup === microcopies[CommonCMS.guide.kids];
    const { showModal } = useGlobalModalContext();

    if (type === ModalTypes.sizeGuide && !(isSocks || isBelts || isLaces || isFootwear || forKids))
        return null;

    return (
        <Text
            as={isToolbar ? SelectDropdownItem : "span"}
            onClick={() =>
                showModal(type, {
                    gender,
                    isFootwear,
                    isSocks,
                    forKids,
                    targetGroup,
                    materialGroup,
                })
            }
            fontWeight="bold"
            fontSize="desktopBodyTextNormal"
            lineHeight="1.2"
            display="inline-flex"
            sx={{
                ...defaultUnderlineStyle,
                cursor: "pointer",
                _hover: {
                    color: "gray.500",
                    textDecorationColor: "gray.500",
                },
            }}
        >
            {microcopies[CommonCMS.size.guideModalTitle]}
        </Text>
    );
};
